var fn = function fn(JsonRPCService) {
    return {
        getAvailableAMACPPClassCodes: function getAvailableAMACPPClassCodes() {
            return JsonRPCService.send('quote', 'quote', 'getaAllAvailableAMACPPClassCodes', []);
        }
    };
};

fn.$inject = ['JsonRPCService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/services/CPPQuoteUtilService.js
// module id = 830
// module chunks = 0